

export const tipoOtorrino = (dataSemiologia) => {
  const { 
    fuma, drogas, vacunas, alergias, 
    nasales, orofaringe, oticos, alcohol, ruido 
  } = dataSemiologia;

  let textoFuma       = '';
  let textoDrogas     = '';
  let textoVacunas    = '';
  let textoAlergias   = '';
  let textoNasales    = '';
  let textoOrofaringe = '';
  let textoOticos     = '';
  let textoAlcohol    = '';
  let textoRuido      = '';

  if(fuma && fuma.active)
    textoFuma = ` empezo a fumar a los ${fuma.edadFuma} años, fuma ${fuma.nCigarrillos} cigarrillos por ${fuma.aniosFuma} años`;

  if(drogas && drogas.active)
    textoDrogas = ` con consumo de drogas ( ${drogas.selected.map( droga => droga.text ).join(', ')} )`;

  if(alcohol) textoAlcohol = ` que consume alcohol`;

  if(ruido) textoRuido = ` con exposicion a ruido`;

  if(vacunas && vacunas.selected.length > 0) 
    textoVacunas = ` con vacunas ( ${vacunas.selected.map( vacuna => vacuna.text ).join(', ')} )`;

  if(alergias && alergias.selected.length > 0) 
    textoAlergias = ` con alergias respiratorias ( ${alergias.selected.map( alergia => alergia.text ).join(', ')} )`;

  if(nasales && nasales.active) 
    textoNasales = ` con sintomas nasales ( ${nasales.selected.map( nasal => nasal.text ).join(', ')} )`;
  
  if(orofaringe && orofaringe.active)
    textoOrofaringe = ` con sintomas relacionados con orofaringe, laringe ( ${orofaringe.selected.map( item => item.text ).join(', ')} )`;

  if(oticos && oticos.active)
    textoOticos = ` con sintomas oticos ( ${oticos.selected.map( item => item.text ).join(', ')} )`;

  return `${textoFuma}${textoDrogas}${textoVacunas}${textoAlergias}${textoNasales}${textoOrofaringe}${textoOticos}${textoAlcohol}${textoRuido}`;
}